import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dynamic-confirm-modal',
  templateUrl: './dynamic-confirm-modal.component.html',
  styleUrls: ['./dynamic-confirm-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicConfirmModalComponent implements OnInit {
@Input() modalTitle:string;
@Input() modalText:string;
@Input() itemName:string;
@Input() modalClass:string = 'danger';
@Input() allButtons:boolean = true;
@Input() buttonText:string = 'auth_confirm';
@Input() backoffice = false;
/** Compatibility inputs retained for existing callers. All contexts use the shared dialog. */
@Input() productDialogPilot = false;
@Input() context = '';
@Input() entityImage = '';
@Input() entityIcon = 'bi-box-seam';
@Input() purpose: 'confirm' | 'leave' | 'discard' = 'confirm';
@Input() saveFn: (() => Promise<void>) | null = null;
isSaving = false;
saveError = '';
imageBroken = false;

get pilotTone(): string {
  return this.modalClass === 'warning' ? 'amber' : this.modalClass === 'danger' ? 'red' : this.modalClass === 'success' ? 'green' : '';
}

async saveAndContinue(): Promise<void> {
  if (!this.saveFn || this.isSaving) return;
  this.isSaving = true;
  this.saveError = '';
  try {
    await this.saveFn();
    this.activeModal.close(true);
  } catch (error) {
    this.saveError = error instanceof Error ? error.message : 'bo_save_failed_retry';
    this.isSaving = false;
  }
}

iconClass:string = "danger bi bi-x-circle-fill";


  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if(this.modalClass === 'success'){
      this.iconClass = this.modalClass + " bi bi-check-circle-fill";
    } else if(this.modalClass != 'danger'){
      this.iconClass = this.modalClass + " bi bi-exclamation-circle-fill";
    }
  }

}
